import { Color, ColorModeVariant } from '@cash-web/protos/squareup/cash/ui/Color.pb'

export const getColorValueFromProto = (
  value?: Color,
  { darkMode = false, supportsP3 = false, prefersMoreContrast = false } = {}
) => {
  const getResultFromMode = (mode?: ColorModeVariant) => {
    let color

    if (prefersMoreContrast) {
      color ??= (supportsP3 && mode?.high_contrast_p3) || mode?.high_contrast_srgb
    }

    return (supportsP3 && mode?.p3) || mode?.srgb
  }

  const darkColor = getResultFromMode(value?.dark)
  const lightColor = getResultFromMode(value?.light)

  return (darkMode && darkColor) || lightColor
}
